import React from 'react';
import RegulationsPageBody from '../components/RegulationsPageBody';

function RegulationsPage() {
    return <RegulationsPageBody />;
}

export default RegulationsPage;